import { useAffiliateData } from "@hooks/affiliates/affiliate/useAffiliateData";
import RichTextViewer from "@components/common/RichTextViewer";
import * as RootS from "../styles";
import * as S from "./styles";

export default function RulesCard() {
  const { data } = useAffiliateData();
  const settings = data?.productAffiliateSettings;

  if (!settings) return <></>;
  return (
    <RootS.ContentCard justifyContent="start" alignItems="start">
      <S.Header>
        <RootS.SubTitle dark margin="none">
          Regras
        </RootS.SubTitle>

        <S.InfoIcon />
      </S.Header>
      <S.Rule>
        <RichTextViewer content={settings?.supportRules} />
      </S.Rule>
    </RootS.ContentCard>
  );
}
